import { render, staticRenderFns } from "./commonQuestionnaire.vue?vue&type=template&id=07520586&scoped=true&"
import script from "./commonQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./commonQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./commonQuestionnaire.vue?vue&type=style&index=0&id=07520586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07520586",
  null
  
)

export default component.exports